import {
  supportSessionHeaders,
  handleSupportSessionFailure,
} from './supportSessionRequests';
import * as Sentry from '@sentry/react';

// Resolves true when the student was linked to the gallery, false otherwise.
// Callers MUST gate navigation on the result: a rejected assignment leaves the
// student unlinked, so advancing the flow strands the parent in an order with
// no gallery attached. The server authorizes by gallery key, so a missing or
// stale key is a normal cause of failure here (see PERSIST_VERSION 6).
const assignStudentToPicsGallery = async (galleryId, studentId, galleryKey) => {
  try {
    const response = await fetch(
      `/api/v3/galleries/${galleryId}/assign-student`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...supportSessionHeaders(),
        },
        body: JSON.stringify({
          student_id: studentId,
          gallery_key: galleryKey,
        }),
      },
    );

    if (
      handleSupportSessionFailure(
        response.status,
        response.headers?.get('X-Support-Session-Ended') === '1',
      )
    )
      return false;

    if (!response.ok) {
      Sentry.captureMessage('Failed to assign student to pics gallery', {
        level: 'error',
        extra: {
          galleryId,
          studentId,
          status: response.status,
          galleryKeyPresent: Boolean(galleryKey),
        },
      });

      return false;
    }

    return true;
  } catch (error) {
    Sentry.captureException(error, {
      extra: { galleryId, studentId, galleryKeyPresent: Boolean(galleryKey) },
    });

    return false;
  }
};

export default {
  assignStudentToPicsGallery,
};
